import { Controller } from 'stimulus';
import universalTracking from '../tracking/universalTracking';

class SpecificationsController extends Controller {
  onToggle() {
    const isOpen = this.bodyTarget.getAttribute('aria-hidden') === 'false';

    this.bodyTarget.style.display = isOpen ? 'none' : 'block';
    this.bodyTarget.setAttribute('aria-hidden', isOpen ? 'true' : 'false');

    this.toggleButtonTargets.forEach((toggleButton) => {
      const hideText = toggleButton.getAttribute('data-hide-text');
      const showText = toggleButton.getAttribute('data-show-text');

      toggleButton.textContent = isOpen ? showText : hideText;
      toggleButton.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });

    if (!isOpen) {
      universalTracking.event('Specifications', 'show');
    }
  }
}

SpecificationsController.targets = [
  'body',
  'toggleButton',
];

export default SpecificationsController;
